export const CATEGORY_NEWS_REQUEST = "CATEGORY_NEWS_REQUEST"
export const CATEGORY_NEWS_SUCCESS = "CATEGORY_NEWS_SUCCESS"
export const CATEGORY_NEWS_FAIL = "CATEGORY_NEWS_FAIL"